// extracted by mini-css-extract-plugin
export default {"newsBoxIFrame":"NewsBoxIFrame_newsBoxIFrame__aZ2DS","newsBoxIFrame__more":"NewsBoxIFrame_newsBoxIFrame__more__D-GX2"};